import { useEffect, useState } from "react";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import { api } from "@/lib/api";
import Footer from "@/components/ui/Footer";
import ShopGrid from "@/components/shop/ShopGrid";

type ShopProduct = {
  id: string;
  slug: string;
  name: string;
  brand: string;
  description: string;
  featured: boolean;
  price: number;
  inventory: number;
  imageUrl: string | null;
  categoryId: string;
};
type Category = { id: string; slug: string; name: string };

type Resp = {
  products: ShopProduct[];
  categories: Category[];
};

export function Shop() {
  const [data, setData] = useState<Resp | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<Resp>("/api/products")
      .then(setData)
      .catch((e) => setErr(e instanceof Error ? e.message : "Failed to load shop"));
  }, []);

  return (
    <div className="min-h-dvh flex flex-col" style={{ backgroundColor: colors.cream }}>
      <main className="flex-1 w-full max-w-6xl mx-auto px-6 pt-32 pb-16">
        <h1 className="text-4xl sm:text-5xl mb-4" style={{ fontFamily: fonts.logo, color: colors.navy }}>A few things for your creative life.</h1>
        <p className="mb-8 leading-relaxed" style={{ fontFamily: fonts.body, fontWeight: 500, color: colors.navy }}>Shop A Few Loose Threads goods. Looking for my favorite sewing tools and supplies? <a className="underline underline-offset-4" href="/favorites">Find them in My Favorites.</a></p>
        {err && <p style={{ color: colors.berryRose, fontWeight: 600 }}>{err}</p>}
        {!data ? (
          <p>Loading shop…</p>
        ) : (
          <ShopGrid products={data.products} categories={data.categories} />
        )}
      </main>
      <Footer />
    </div>
  );
}
